import dayjs from 'dayjs';
export type { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import isYesterday from 'dayjs/plugin/isYesterday';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import minMax from 'dayjs/plugin/minMax';
import weekday from 'dayjs/plugin/weekday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import businessDays from 'dayjs-business-days2';

import 'dayjs/locale/fr';

import { DayName, nextNamedDay, previousNamedDay } from './dayjs.helper';

const plugins = [
  utc,
  timezone,
  duration,
  isBetween,
  isToday,
  isTomorrow,
  isYesterday,
  isSameOrAfter,
  isSameOrBefore,
  advancedFormat,
  localeData,
  customParseFormat,
  updateLocale,
  minMax,
  weekday,
  localizedFormat,
  quarterOfYear,

  businessDays,
];

plugins.forEach((plugin) => dayjs.extend(plugin));

dayjs.extend(relativeTime); //to avoid error when putting in the plugins array

declare module 'dayjs' {
  interface Dayjs {
    nextNamedDay(dayName: DayName): Dayjs;
    previousNamedDay(dayName: DayName): Dayjs;
  }
}

dayjs.prototype.nextNamedDay = nextNamedDay;
dayjs.prototype.previousNamedDay = previousNamedDay;

export const DateUtils = dayjs;
